import type { SavedFile } from "./files.types";
import type { VariantType } from "./variant.types";

export type VariantOption = {
	uuid: string;
	label: string;
	sageId: string;
	cost: number; // in cents
	description?: string;
	fileId?: number | string | null;
	file?: File | SavedFile | null;
};

export enum VariantConditionInnerOperator {
	EQUAL = "==",
	NOT_EQUAL = "!=",
}

export type VariantConditionInner = {
	variantId: number | null;
	operator: VariantConditionInnerOperator;
	values: string[];
};

export type VariantCondition = {
	targets: string[];
	conditions: VariantConditionInner[];
};

export type Variant = {
	id: number;
	uuid: string;
	label: string;
	description: string;
	options: {
		data: VariantOption[];
		conditions: VariantCondition[];
	};
	fileId?: number | string | null;
	file?: File | SavedFile | null;
	type: VariantType;
};

export enum EarmoldStatus {
	DRAFT = "DRAFT",
	ACTIVE = "ACTIVE",
}

export enum EarmoldCategory {
	HEARING_AID = "HEARING_AID",
	PROTECTION = "PROTECTION",
	COMM_AND_MONITORING = "COMM_AND_MONITORING",
	OTHER = "OTHER",
}

export type Earmold = {
	id: number;
	uuid: string;
	label: string;
	description: string | null;
	status: EarmoldStatus;
	type: EarmoldCategory;
	category: EarmoldCategory;
	variants: Variant[];
	price: number;
	sageId: string;
	fileId: number | null;
	file: File | SavedFile | null;
};
